import { useEffect, useState } from "react";

import GlanumLeaflet from "./component/GlanumLeaflet";
import Loader2 from "./component/Loader2";
import FetchData from "./utils/fetchData";

const Container = () => {
  const [dataIsReturned, setDataIsReturned] = useState(false);
  const [json, setJson] = useState({});
  const [fetchError, setFetchError] = useState(false);

  const url = document.getElementById("root").dataset.url;
  const params = document.getElementById("root").dataset.params || "";

  useEffect(() => {
    fetch(url + params)
      .then((response) => response.json())
      .then((jsonData) => {
        setJson(jsonData);
        setDataIsReturned(true);
      })
      .catch((error) => {
        // handle your errors here
        setFetchError(true);
      });
  }, []);

  if (process.env.REACT_APP_DEPLOY === "prod") {
    if (fetchError) {
      return (
        <>
          <div className="display_error">
            <h2>Oups ! Une erreur est survenue.</h2>
          </div>
        </>
      );
    }

    if (!dataIsReturned) {
      return (
        <>
          <Loader2 />
        </>
      );
    } else if (json) {
      return <GlanumLeaflet data={json} />;
    } else {
      return <div>Error</div>;
    }
  } else if (process.env.REACT_APP_DEPLOY === "dev") {
    let data = FetchData("url");
    return <GlanumLeaflet data={data} />;
  }
};

export default Container;
